import React from "react"
import {OkDocument} from "../../resources/common"
import {
	isBusinessProductApplicationDocument,
	isIndividualProductApplicationDocument,
	ProductApplication,
} from "../../resources/productApplication"
import ReevaluateBusinessProductApplicationContainer from "./ReevaluateBusinessProductApplicationContainer"
import ReevaluateIndividualProductApplicationContainer from "./ReevaluateIndividualProductApplicationContainer"
import Admonition from "../../components/Admonitions/Admonition"

interface ReevaluateProductApplicationContainerProps {
	application: OkDocument<ProductApplication>
}

export default function ReevaluateProductApplicationContainer({
	application,
}: ReevaluateProductApplicationContainerProps) {
	if (isBusinessProductApplicationDocument(application)) {
		return <ReevaluateBusinessProductApplicationContainer application={application} />
	} else if (isIndividualProductApplicationDocument(application)) {
		return <ReevaluateIndividualProductApplicationContainer application={application} />
	}

	return <Admonition type="is-danger" title="Invalid product application type" message={""} />
}
